import React, {Component} from 'react';
import InputValidationError from "../common/InputValidationError";

export default class QuotesManualAddress extends Component {
    render() {
        const {onChange, info, toggleManualAddress, errors} = this.props;
        return (
            <section className="quotes-form-manual-address">
                <div className='container pb-5'>
                    <div className="row justify-content-center py-3">
                        <h4 className="quotes-heading">Enter address</h4>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="text" name='property_number'
                                       className='form-control quotes-form-input'
                                       onChange={onChange}
                                       value={info.property_number}
                                       placeholder='Flat or Property Number'/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="text" name='street_name' className='form-control quotes-form-input'
                                       onChange={onChange}
                                       value={info.street_name}
                                       placeholder='Street Name'/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="text" name='city_name' className='form-control quotes-form-input'
                                       onChange={onChange}
                                       value={info.city_name}
                                       placeholder='City Name'/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="text" name='postcode' className='form-control quotes-form-input'
                                       onChange={onChange}
                                       value={info.postcode}
                                       placeholder='Postcode'/>
                            </div>
                        </div>
                    </div>
                    <div className='pull-right row px-3'>
                        <small className="text-danger">
                            <a href="#" onClick={toggleManualAddress} style={{color: '#3F3F3F'}}>
                                Find your address
                            </a>
                        </small>
                    </div>
                    <InputValidationError error={errors.address}/>
                </div>
            </section>
        );
    }
}
